import { React, useState, useEffect } from "react";
import styled from "styled-components";
import { toTitleCase } from "../../assets/js/help_func";
import { useRouter } from "next/router";

const FilterObjects = (props) => {
	const [isActive, setIsActive] = useState(false);
	const [selected, setSelected] = useState(
		props.defaultValues && props.defaultValues.title
			? toTitleCase(props.defaultValues.title)
			: "Choose..."
	);
	const [objects, setObjects] = useState([]);
	const [id, setID] = useState(props.defaultValues?.id || "");
	useEffect(() => {
		/* 
        Objects trows error when you loop with map or forEach.
        Solution: convert objects list to array.
    */
		let obj = [];
		for (const i in props.options) obj.push(props.options[i]);
		setObjects(obj);
	}, [props.options, id]);

	const router = useRouter();
	const { query } = router;
	const handleUpdateQueryParam = (values) => {
		// Update the search params onChange
		const newQuery = { ...query };
		newQuery[props.paramsName] = values;
		router.replace({
			query: newQuery,
		});
	};

	return (
		<SelectMe className="select_me">
			<div className="select-btn" onClick={(e) => setIsActive(!isActive)}>
				<div>
					<input
						type="text"
						className="dropdown input_drop"
						defaultValue={props.upperCases ? id.toUpperCase() : id}
						id={"id_" + props.names}
						name={props.names}
						readOnly
					/>
					<p>
						{selected.length > 30 ? selected.slice(0, 30) + "..." : selected}
					</p>
				</div>
				<label className="filter_label">{props.labels}</label>
				{/* {selected} */}
				<img
					src="https://www.svgrepo.com/show/379863/chevron-down.svg"
					alt=""
				/>
			</div>
			{isActive && (
				<div className="select_content">
					{objects.map((option, index) => (
						<div
							className="select_items"
							onClick={(e) => {
								setSelected(option.title);
								setID(option.id);
								setIsActive(false);
								if (props.updateParams === "true") {
									handleUpdateQueryParam(option.id);
								}
								if (props.setSelectedValue) props.setSelectedValue(option);
							}}
							key={index}
						>
							{option.title}
						</div>
					))}
				</div>
			)}
		</SelectMe>
	);
};

export default FilterObjects;

const SelectMe = styled.div`
	width: 100%;
	min-width: 350px;
	margin: 30px 0px;

	.select-btn input:focus {
		border: none;
	}
	.select-btn p {
		margin: 0px;
	}
	.select-btn input {
		display: none;
	}
	.select_content {
		z-index: 10;
		max-height: 300px;
		overflow: scroll;
	}
	.filter_label {
		background: #ffffff;
		top: -10px;
		height: 20px;
		padding: 5px;
		margin: 0;
		color: #00838f;
		font-size: 14px;
		pointer-events: initial;
		left: 15px;
		line-height: 10px;
		position: absolute;
		top: -9px;
		left: 15px;
		-webkit-transition: all 0.3s ease;
		transition: all 0.3s ease;
		pointer-events: none;
	}
`;
